import { ref } from 'vue'
import { defineStore } from 'pinia'

import { useApi } from '../../composables/api'

export const useProblemReportStore = defineStore('problemReport', () => {
  const { problemReportsApi } = useApi()

  const isSending = ref(false)

  /** True when the report reached the server. The api shows its own message when it did not. */
  async function send(
    form: { message: string; contactEmail?: string; pagePath?: string },
    turnstileToken: string
  ): Promise<boolean> {
    isSending.value = true
    try {
      await problemReportsApi.problemReportsSubmitProblemReport({
        problemReportRequest: {
          message: form.message.trim(),
          contactEmail: form.contactEmail?.trim() || null,
          pagePath: form.pagePath || null
        },
        turnstileToken
      })
      return true
    } catch {
      return false
    } finally {
      isSending.value = false
    }
  }

  return { isSending, send }
})
